const SOCIALS = [
  { label: "TikTok", href: "https://www.tiktok.com/@sisterhood.plus", type: "tiktok" },
  { label: "Facebook", href: "https://www.facebook.com/people/Sisterhood-Plus/61595707255653/", type: "facebook" },
];

function TikTokGlyph({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.5 3c.3 2.1 1.5 3.5 3.5 3.7v2.4c-1.2.1-2.4-.2-3.5-.8v5.9c0 3.2-2.6 5.8-5.8 5.8S5 19.4 5 16.2s2.6-5.8 5.8-5.8c.3 0 .6 0 .9.1v2.5c-.3-.1-.6-.1-.9-.1-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3V3h2.4z" />
    </svg>
  );
}

function FacebookGlyph({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z" />
    </svg>
  );
}

const GLYPH = { tiktok: TikTokGlyph, facebook: FacebookGlyph };

/** Labeled social icons for Sisterhood+ brand profiles, matching the warm footer style. */
export default function SocialLinks({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2.5 ${className}`} data-testid="social-links">
      {SOCIALS.map((s) => {
        const Glyph = GLYPH[s.type];
        return (
          <a key={s.type} href={s.href} target="_blank" rel="noopener noreferrer"
            aria-label={`Sisterhood+ on ${s.label}`} data-testid={`social-${s.type}`}
            className="inline-flex items-center gap-1.5 rounded-full border border-[#291B2D]/10 px-3 py-1.5 text-xs text-[#291B2D]/65 hover:bg-[#F7F2EA] hover:text-[#291B2D] transition-smooth">
            <Glyph size={14} /><span>{s.label}</span>
          </a>
        );
      })}
    </div>
  );
}
